const translations = {
  // Nav
  nav_home: "Начало",
  nav_about: "За фонда",
  nav_plans: "Пенсионни планове",
  nav_calculator: "Калкулатор",
  nav_benefits: "Предимства",
  nav_contact: "Контакти",
  nav_open_account: "Отвори сметка",

  // Hero
  hero_badge: "Норвежки държавен пенсионен фонд",
  hero_title_1: "Вашето финансово",
  hero_title_2: "бъдеще",
  hero_title_3: "започва днес",
  hero_desc: "Инвестиционни договори с гарантирана доходност от 3% до 198%. Стабилни пенсионни плащания и дивидентен доход всеки месец.",
  hero_cta_calc: "Изчисли пенсия",
  hero_cta_learn: "Научи повече",
  hero_stat_assets: "Активи под управление",
  hero_stat_companies: "Компании в портфолиото",
  hero_stat_countries: "Страни на инвестиране",
  hero_stat_years: "Години опит",

  // About
  about_badge: "За фонда",
  about_title_1: "Най-големият суверенен",
  about_title_2: "пенсионен фонд в света",
  about_desc1: "Government Pension Fund Global (GPFG) е норвежкият държавен пенсионен фонд, основан през 1990 г. Фондът управлява активи на стойност над €1,4 трилиона, което го прави най-големия суверенен фонд в света.",
  about_desc2: "Фондът инвестира в акции на над 9 000 компании в 70 страни, осигурявайки максимална диверсификация и защита на капитала. Всеки инвестиционен договор е гарантиран от норвежката държава.",
  about_feat1: "Рейтинг Moody's AAA",
  about_feat2: "Министерство на финансите на Норвегия",
  about_feat3: "Инвестиции в 70 страни",
  about_feat4: "100% държавна гаранция",
  about_cta: "Избери план",
  about_years: "години надеждна работа",

  // Plans
  plans_badge: "Инвестиционни договори",
  plans_title: "Изберете вашия пенсионен план",
  plans_desc: "Три нива на инвестиционни договори с гарантирана доходност. Колкото по-висока е сумата — толкова по-голям е дивидентният доход.",
  plans_badge1: "Базово ниво",
  plans_badge2: "Популярен избор",
  plans_badge3: "Максимална изгода",
  plans_tier1: "Стартов",
  plans_tier2: "Оптимален",
  plans_tier3: "Премиум",
  plans_contract: "инвестиционен договор",
  plans_per_month: "на месец",
  plans_monthly: "Месечно:",
  plans_sign: "Подпиши договор",
  plans_feat1_1: "3–5% месечна доходност",
  plans_feat1_2: "Месечни плащания",
  plans_feat1_3: "Държавна гаранция",
  plans_feat1_4: "Онлайн сметка на инвеститора",
  plans_feat1_5: "Безплатна консултация",
  plans_feat2_1: "До 103% месечна доходност",
  plans_feat2_2: "Увеличени дивиденти",
  plans_feat2_3: "Приоритетно обслужване",
  plans_feat2_4: "Личен мениджър",
  plans_feat2_5: "Реинвестиране на печалбата",
  plans_feat3_1: "157–198% месечна доходност",
  plans_feat3_2: "VIP обслужване",
  plans_feat3_3: "Личен мениджър",
  plans_feat3_4: "Тримесечни бонуси",
  plans_feat3_5: "Ексклузивни инвестиции",
  plans_disclaimer: "* Доходността се основава на исторически данни на фонда. Инвестициите са защитени от държавната гаранция на Норвегия.",

  // Calculator
  calc_badge: "Калкулатор на доходността",
  calc_title: "Изчислете вашата бъдеща пенсия",
  calc_promo: "От <1>€3 000</1> — вече <2>103%</2> на месец!",
  calc_promo_pre: "От",
  calc_promo_mid: "— вече",
  calc_promo_post: "на месец!",
  calc_amount_label: "Сума на договора",
  calc_tier1_label: "3–5%",
  calc_tier1_sub: "до €3 000",
  calc_tier2_label: "103% 🔥",
  calc_tier2_sub: "от €3 000",
  calc_tier3_label: "157%",
  calc_tier3_sub: "от €5 000",
  calc_tier4_label: "198%",
  calc_tier4_sub: "€10 000",
  calc_return_label: "Доходност по план",
  calc_per_year: "на месец",
  calc_monthly_label: "Месечна пенсия",
  calc_monthly_sub: "на месец",
  calc_dividend_label: "Годишен дивидентен доход",
  calc_dividend_sub: "на година",
  calc_tip: "От <1>€3 000</1> вашата доходност е <2>103% на месец</2>. При €10 000 — максимум <3>198%</3>.",
  calc_cta: "Подпиши инвестиционен договор",

  // Benefits
  benefits_badge: "Защо да ни изберете",
  benefits_title: "Предимства на Government Pension Fund Global",
  benefits_desc: "От над 35 години осигуряваме стабилен пенсионен и дивидентен доход за хиляди инвеститори по целия свят",
  benefits_adv1_title: "Държавна гаранция",
  benefits_adv1_desc: "Вашите инвестиции са защитени от държавата. Фондът работи под надзора на Министерството на финансите на Норвегия от 1990 г.",
  benefits_adv2_title: "Стабилен растеж",
  benefits_adv2_desc: "Средната годишна доходност на фонда за последните 25 години надвишава 6%. Вашият капитал работи за вас.",
  benefits_adv3_title: "Дивидентен доход",
  benefits_adv3_desc: "Получавайте месечни дивидентни плащания директно по вашата сметка. Прозрачна отчетност и пълен контрол.",
  benefits_adv4_title: "Глобална диверсификация",
  benefits_adv4_desc: "Портфолиото включва акции на над 9 000 компании в 70 страни. Максимална защита от рискове.",
  benefits_adv5_title: "Персонален подход",
  benefits_adv5_desc: "Всеки клиент получава личен мениджър и индивидуален инвестиционен план.",
  benefits_adv6_title: "Гъвкави условия",
  benefits_adv6_desc: "Изберете срок на договора от 5 до 30 години. Ранно излизане без неустойки.",
  benefits_passive_badge: "Пасивен доход",
  benefits_passive_title1: "Получавайте стабилни",
  benefits_passive_title2: "дивиденти всеки месец",
  benefits_passive_desc1: "Дивидентният доход е вашата пасивна печалба от инвестиции в най-големите световни компании. Фондът разпределя печалбата между инвеститорите всеки месец, осигурявайки стабилен паричен поток.",
  benefits_passive_desc2: "Можете да реинвестирате дивидентите за ускорен растеж на капитала или да ги получавате по сметката — изборът е ваш.",
  benefits_li1: "Плащания всеки месец без закъснения",
  benefits_li2: "Реинвестиране на печалбата за растеж",
  benefits_li3: "Прозрачна онлайн отчетност",
  benefits_li4: "Данъчна оптимизация за инвеститори",
  benefits_stat1: "Максимално месечно плащане",
  benefits_stat2: "Максимална доходност",
  benefits_stat3: "Плащания на година",
  benefits_stat4: "Държавна гаранция",
  benefits_reviews_title: "Историите на нашите клиенти",
  benefits_reviews_sub: "Реални отзиви от инвеститори на Government Pension Fund Global",
  benefits_t1_text: "\"Инвестирах €10 000 преди три години и сега получавам стабилни €4 200 всеки месец. Това промени живота ми!\"",
  benefits_t1_name: "Анна Мюлер",
  benefits_t1_meta: "67 · Берлин · Премиум",
  benefits_t2_text: "\"Government Pension Fund Global означава надеждност и стабилност. Моят дивидентен доход расте всяка година.\"",
  benefits_t2_name: "Клаус Берг",
  benefits_t2_meta: "71 · Осло · Оптимален",
  benefits_t3_text: "\"Започнах с начален план, преминах към премиум след година. Сега пътувам по света с пенсионните си плащания.\"",
  benefits_t3_name: "Мария Хансен",
  benefits_t3_meta: "64 · Копенхаген · Премиум",

  // Contact
  contact_badge: "Свържете се с нас",
  contact_title1: "Започнете да получавате",
  contact_title2: "пенсионен доход днес",
  contact_desc: "Оставете заявка и нашият личен мениджър ще се свърже с вас в рамките на 24 часа. Ще ви помогнем да изберете оптималния инвестиционен договор и ще отговорим на всички въпроси.",
  contact_phone_label: "Телефон",
  contact_email_label: "Имейл",
  contact_address_label: "Адрес",
  contact_hours_label: "Работно време",
  contact_hours_val: "Пон–Пет: 09:00–18:00 (CET)",
  contact_form_title: "Оставете заявка",
  contact_fname: "Име",
  contact_fname_ph: "Вашето име",
  contact_lname: "Фамилия",
  contact_lname_ph: "Вашата фамилия",
  contact_email: "Имейл",
  contact_phone: "Телефон",
  contact_plan: "Интересуващ план",
  contact_plan_ph: "Изберете план",
  contact_plan1: "Стартов — €3 000 (3–5%)",
  contact_plan2: "Оптимален — €5 000 (103%)",
  contact_plan3: "Премиум — €10 000 (157–198%)",
  contact_msg: "Съобщение",
  contact_msg_ph: "Вашите въпроси или пожелания...",
  contact_submit: "Изпрати заявка",
  contact_submitting: "Изпращане...",
  contact_success_title: "Заявката е изпратена!",
  contact_success_desc: "Нашият мениджър ще се свърже с вас в рамките на 24 часа.",
  contact_privacy: "Като кликнете бутона, вие се съгласявате с политиката за поверителност",

  // Footer
  footer_cta_title: "Готови ли сте да започнете да инвестирате?",
  footer_cta_desc: "Отворете инвестиционен договор днес и започнете да получавате пенсионен доход",
  footer_cta_btn: "Отвори сметка",
  footer_about_desc: "Най-големият суверенен пенсионен фонд в света. Надеждни инвестиции с държавна гаранция.",
  footer_col1: "За фонда",
  footer_col1_l1: "История на фонда",
  footer_col1_l2: "Управленски екип",
  footer_col1_l3: "Годишни доклади",
  footer_col1_l4: "Прес-център",
  footer_col2: "Инвестиции",
  footer_col2_l1: "Пенсионни планове",
  footer_col2_l2: "Калкулатор на доходността",
  footer_col2_l3: "Дивидентен доход",
  footer_col2_l4: "Портфолио на фонда",
  footer_col3: "Поддръжка",
  footer_col3_l1: "FAQ",
  footer_col3_l2: "Личен акаунт",
  footer_col3_l3: "Свържете се с нас",
  footer_col3_l4: "Документи",
  footer_col4: "Правна информация",
  footer_col4_l1: "Политика за поверителност",
  footer_col4_l2: "Условия за ползване",
  footer_col4_l3: "Лицензи",
  footer_col4_l4: "Разкриване на информация",
  footer_copy: "© 2026 Government Pension Fund Global. Всички права запазени.",
  footer_disclaimer: "Инвестициите са свързани с рискове. Миналите резултати не гарантират бъдеща доходност. Фондът е под надзора на Министерството на финансите на Норвегия.",

  // Live notification
  notif_received: "получи",
  notif_plan: "Премиум",

  // Plans tiers in calculator
  calc_plan_starter: "Стартов",
  calc_plan_optimal: "Оптимален",
  calc_plan_advanced: "Разширен",
  calc_plan_premium: "Премиум",
};

export default translations;
